import $ from 'jquery';
import 'bootstrap/js/dist/modal';

function toggleApiOptions() {
  var api = $("#download_data_api");
  var optionsContainer = $("#api_options_" + api.val());
  var fileFormatDetails = $("#api_file_format_details_" + api.val());

  // only show the timeframe option for stations downloads
  $('#stationsTimeframe').hide();
  // show/hide the historical stations download options
  if (api.val() === 'alt_fuel_stations') {
    $('#stationsTimeframe').show();
    var selectedTimeframe = $('#stationsTimeframe input:checked').val();

    if (selectedTimeframe === 'historical') {
      optionsContainer = $("#api_options_historical_stations");
      fileFormatDetails = $("#api_file_format_details_historical_stations");
    }
  }

  $(".api-options").hide();
  if(optionsContainer) {
    optionsContainer.show();
  }

  $(".api-file-format-details").hide();
  if(fileFormatDetails) {
    fileFormatDetails.show();
  }
}

function showHideHistoricalStationOptions() {
  var selectedOption = $("div#historicalDownloadType input:checked").val();

  $("[class*=historicalField]").hide();

  if(selectedOption) {
    if(selectedOption == "historicalSingleDay") {
      $("[class*=historicalFieldSingleDay]").show();
    } else if (selectedOption == "historicalDateRange") {
      $("[class*=historicalFieldDateRange]").show();
    } else if (selectedOption == "historicalChangesSummary") {
      $("[class*=historicalFieldSummary]").show();
    }
  }
}

const originalStatesHtml = new WeakMap();
function showHideStatesProvinces() {
  const selectedCountry = $(this).children('option:selected').val();
  const form = $(this).prop("id");
  let dropdownEl;

  // determine which state/province dropdown to target
  if (form == "download_data_api_options_alt_fuel_stations_country") {
    dropdownEl = document.getElementById('download_data_api_options_alt_fuel_stations_state');
  } else {
    dropdownEl = document.getElementById('download_data_api_options_historical_stations_state');
  }

  // store original options if not already stored
  if (!originalStatesHtml.has(dropdownEl)) {
    const originalHtmlTemplate = document.createElement('template');
    originalHtmlTemplate.innerHTML = dropdownEl.innerHTML;
    originalStatesHtml.set(dropdownEl, originalHtmlTemplate.content);
  }

  // create a temporary container to work with original HTML
  const originalHtmlFragment = originalStatesHtml.get(dropdownEl).cloneNode(true);
  const newHtmlFragment = new DocumentFragment();

  let selectedCountryLabel;
  if (selectedCountry == "US") {
    selectedCountryLabel = "US";
  } else if (selectedCountry == "CA") {
    selectedCountryLabel = "Canada";
  }

  if (selectedCountryLabel) {
    newHtmlFragment.append(...originalHtmlFragment.querySelectorAll('option[value="all"]'));
    newHtmlFragment.append(...originalHtmlFragment.querySelectorAll(`optgroup[label="${selectedCountryLabel}"]`));
  } else {
    newHtmlFragment.append(originalHtmlFragment);
  }

  // Repace the contents of the <select> element with the new fragment of
  // appropriate options.
  dropdownEl.innerHTML = '';
  dropdownEl.appendChild(newHtmlFragment);
}

$(document).ready(function() {
  toggleApiOptions();
  $("#download_data_api").change(toggleApiOptions);

  function updateFileFormats() {
    var dataset = $("#download_data_api");
    var timeframe = $("#stationsTimeframe input:checked").val()
    if(dataset.val() === "alt_fuel_stations" && (timeframe === "current" || (timeframe === "historical" && $("#historicalDownloadType input:checked").val() === 'historicalSingleDay'))) {
      if ($("#download_data_format option[value='geojson']").length === 0) {
        $("#download_data_format option[value='json']").before($("<option></option>").val("geojson").text("GeoJSON"));
      }
      if ($("#download_data_format option[value='kml']").length === 0) {
        $("#download_data_format option[value='xml']").before($("<option></option>").val("kml").text("KML"));
      }
    } else {
      $("#download_data_format option[value='geojson']").remove();
      $("#download_data_format option[value='kml']").remove();
    }

    // only show the 'File Format' input if a dataset is selected
    $("#fileFormat").hide();
    if (dataset.val() != "") $("#fileFormat").show();
  }
  $('#download_data_api, #stationsTimeframe, #historicalDownloadType').change(updateFileFormats);
  $('#download_data_api').trigger('change');
  $('#stationsTimeframe').change(toggleApiOptions);
  $('#historicalDownloadType').change(showHideHistoricalStationOptions);
  $('#historicalDownloadType').trigger('change');
  $('#download_data_api_options_historical_stations_country, #download_data_api_options_alt_fuel_stations_country').change(showHideStatesProvinces);
  $('#download_data_api_options_historical_stations_country, #download_data_api_options_alt_fuel_stations_country').trigger('change');
});

$('abbr[title="required"]').css('color', '#E87723');
$('option[value="spacer"]').remove();
$('#download_data_api_options_heavy_duty_vehicles_category_id')[0].selectedIndex = 0;
$('#download_data_api_options_heavy_duty_vehicles_fuel_id')[0].selectedIndex = 0;
$('#download_data_api_options_heavy_duty_vehicles_manufacturer_id')[0].selectedIndex = 0;
